<template>
  <section>
    <form @submit.prevent="submit">
      <z-dialog :show="isVisible" :modal-size="modalSize" :d-style="'z-index: 1070'" :bd-style="'z-index: 1065'">
        <template #header>
          <div class="row custom-header">
            <div class="col">
              <h4 class="modal-title">
                {{ title }}
              </h4>
            </div>
            <div class="col-1">
              <a href="#" class="custom-close" @click="close">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
        </template>
        <template #body>
          <div class="custom-body">
            <div class="row mb-2">
              <div class="col">
                <span>{{ triggerFor }}</span>
              </div>
            </div>
            <z-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
            <div v-if="currentTab === 'HTML'" class="row p-3 custom-form">
              <div class="col form-group custom-editor">
                <editor ref="zEditorTrigger" v-model:content="triggerHtml" content-type="html" />
              </div>
            </div>
            <div v-if="currentTab === 'Text'" class="row p-3 custom-form">
              <div class="col form-group">
                <textarea v-model="textOnly" class="custom-text-only"></textarea>
              </div>
            </div>
          </div>
        </template>
        <template #footer>
          <div class="row custom-footer">
            <div class="col">
              <p>
                For a more capable online HTML editor, use <a href="https://bestonlinehtmleditor.com/" target="_blank">WYSIWYG Editor</a>. When
                finished editing there, copy and paste into this HTML editor.
              </p>
            </div>
            <div class="col-2 custom-right-align">
              <button type="button" class="btn btn-primary" @click="close()">Ok</button>
            </div>
          </div>
        </template>
      </z-dialog>
    </form>
  </section>
</template>
<script>
import { mapActions } from 'pinia'
import { adasmatrixStore } from '@/stores/adasmatrix'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import Editor from '@/components/utilities/elements/Editor.vue'
export default {
  name: 'DialogTrigger',
  components: {
    ZDialog,
    ZTabs,
    Editor
  },
  props: {
    modelValue: Object
  },
  data() {
    return {
      message: null,
      modalSize: 'modal-lg',
      currentTab: 'HTML',
      tabs: ['HTML', 'Text'],
      options: {
        maxHeight: '400px'
      }
    }
  },
  emits: ['input', 'closing', 'changed'],
  computed: {
    isVisible() {
      return this.modelValue !== null
    },
    title() {
      return 'Trigger Notification'
    },
    triggerFor() {
      let _data = ''
      if (this.modelValue) {
        _data = `${this.modelValue.location}: ${this.modelValue.system}`
      }
      return _data
    },
    triggerHtml: {
      get() {
        let _trigger = ''
        if (this.modelValue) {
          if (this.modelValue.triggerNotice) {
            _trigger = this.decodeHtml(this.modelValue.triggerNotice)
          }
        }
        return _trigger
      },
      set(value) {
        // /(<style[\w\W]+style>)/g
        // /<style.*?<\/style>/g
        // <style([\S\s]*?)>([\S\s]*?)<\/style>
        // /(\w+)="(.*?)"/g
        // const html = value.replace(/(\w+)="(.*?)"/g, '')
        this.updateAdasMakeMatrix({
          name: 'triggerNotice',
          value: value
        })
        this.convertToText()
      }
    },
    textOnly() {
      let _trigger = ''
      if (this.modelValue) {
        if (this.modelValue.triggerNoticeText) {
          _trigger = this.modelValue.triggerNoticeText
        }
      }
      return _trigger
    }
  },
  methods: {
    ...mapActions(adasmatrixStore, ['updateAdasMakeMatrix']),
    close() {
      this.$emit('closing')
    },
    showTab(value) {
      this.currentTab = value
    },
    setHtml(value) {
      setTimeout(() => {
        this.$refs.zEditorTrigger.setHTML(value)
      }, 100)
    },
    decodeHtml(html) {
      var txt = document.createElement('textarea')
      txt.style.display = 'none' // Ensure it's not visible
      document.body.appendChild(txt) // Temporarily add it to the DOM
      txt.innerHTML = html
      var decodedHtml = txt.value
      document.body.removeChild(txt) // Clean up by removing the element
      return decodedHtml
    },
    convertToText() {
      var textContent = ''
      var temp = document.getElementsByClassName('editr--content')[0]
      if (temp !== undefined && temp !== null) {
        textContent = temp.textContent // temp.innerHTML.replace().replace(/<[^>]+>/g, '')
        if (textContent.indexOf('-->') > 0) {
          textContent = textContent.substring(textContent.indexOf('-->') + 3)
        }
        if (textContent.indexOf('<!--') > 0) {
          textContent = textContent.substring(0, textContent.indexOf('<!--'))
        }
        textContent = textContent.trim()
      }
      this.updateAdasMakeMatrix({
        name: 'triggerNoticeText',
        value: textContent
      })
      this.$emit('changed')
    },
    submit() {}
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  color: #000;
  cursor: pointer;
}
.custom-body {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 500px;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-right-align {
  text-align: right;
}
.custom-value-wrapper {
  position: relative;
  top: 35px;
}
.custom-text-only {
  width: 100%;
  height: 300px;
}
.custom-editor {
  height: 300px;
  margin-bottom: 40px;
}
</style>
